/* global app */

define('browsercheck', [
    'jquery',
    '../vendor/uaparser-0.7.14.min'
], function($, UAParser) {
    let Amigo;
    let browser = '';
    let funnelValue = false;

    try {
        Amigo = [[/(Amigo)\/([\w\.]+)/i], [UAParser.BROWSER.NAME, UAParser.BROWSER.VERSION]];

        UAParser = new UAParser({browser: Amigo});

        UAParser.setUA(app.config.user_agent);

        app.config.user_os = UAParser.getOS();
        app.config.user_browser = UAParser.getBrowser();

        browser = app.config.user_browser.name.toLowerCase();
        browser = browser.replace(/mobile\s*/i, '');

        switch (browser) {
            case 'chrome':
                funnelValue = 1;
                break;
            case 'yandex':
                funnelValue = 2;
                break;
            case 'opera':
                funnelValue = 3;
                break;
            case 'firefox':
                funnelValue = 4;
                break;
            case 'amigo':
                funnelValue = 5;
                break;
            case 'ie':
                funnelValue = 6;
                break;
            case 'edge':
                funnelValue = 6;
                break;
            case 'safari':
                funnelValue = 7;
                break;
        }

        if (funnelValue && typeof window._funnel !== 'undefined') {
            window._funnel.send({
                type: 'e',
                name: 'initialize_web.browser',
                value: funnelValue,
                reg: 0
            });
        }

        if (browser !== '') {
            $('body').addClass(browser);
        }

        try {
            window.Sentry.configureScope(function(scope) {
                scope.setTag('cpu_arch', UAParser.getCPU().architecture);
            });
        } catch (e) {
            console.error(e);
        }

        return UAParser;
    } catch (e) {
        console.log('browsercheck error', e);
    }
});
